import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Select, Modal } from 'antd';
import { useQueryClient } from 'react-query';
import {
  Column, Container, InviteContainer, ModalTitle, Row,
} from './styles';
// import Modal from '../Modal';
import membersIcon from '../../assets/images/members.svg';
import useAuth from '../../hooks/useAuth';
import { Button } from '../Button';
import useWorkspaces from '../../hooks/useWorkspaces';
import httpClient from '../../datasources/httpClient';

const { Option } = Select;
export default function MembersButton({ workspace, workspaceAlreadySelected }) {
  const { setWorkspace, workspace: selectedWorkspace } = useWorkspaces();
  const [users, setUsers] = useState([]);
  const [memberRole, setMemberRole] = useState();
  const [memberEmail, setMemberEmail] = useState();
  const [open, setOpen] = useState(false);

  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { members, roles } = workspace;

  useEffect(() => {
    const fetchUsers = async () => {
      const response = await httpClient.get('users');

      if (response.data) {
        setUsers(response.data);
      }
    };

    const workspaceId = localStorage.getItem('modalWorkspaceId');
    if (workspaceId === workspace.id) {
      setOpen(localStorage.getItem('membersModal') ?? false);
    }

    fetchUsers();
  }, []);

  const availableNewMembers = users
    .filter((element) => members?.filter((member) => member.email === element.email).length === 0);

  async function handleCreateNewMember() {
    const response = await httpClient.post('members', {
      email: memberEmail,
      roleName: memberRole,
      workspaceId: workspace.id,
    });

    if (response.status === 202) {
      queryClient.invalidateQueries('workspaces');
    }
  }

  function handleClose() {
    if (!workspaceAlreadySelected) {
      setWorkspace(null);
    }
    setOpen(false);
    localStorage.setItem('membersModal', false);
    localStorage.setItem('modalWorkspaceId', null);
  }

  function handleOpen() {
    setOpen(true);
    setWorkspace(workspace);
    localStorage.setItem('membersModal', true);
    localStorage.setItem('modalWorkspaceId', workspace.id);
  }

  return (
    <Container>
      <Modal
        open={selectedWorkspace?.id === workspace.id && open}
        onCancel={() => handleClose()}
        onOk={() => handleClose()}
        footer={null}
      >
        <Column>
          <ModalTitle>
            Compartilhar
            {' '}
            {selectedWorkspace?.name}
          </ModalTitle>
          <InviteContainer>
            <Select
              placeholder="Endereço de e-mail"
              showSearch
              optionFilterProp="children"
              value={memberEmail}
              onSelect={(value) => setMemberEmail(value)}
              filterOption={(input, option) => option.children.includes(input)}
              style={{
                color: 'black',
                width: '100%',
                marginRight: '8px',
                alignSelf: 'center',
              }}
            >
              {
                availableNewMembers.map((element) => (
                  <Option value={element.email} key={`MEMBER_OPTION_${element.email}`}>
                    {element.name}
                  </Option>
                ))
              }
            </Select>
            <Select
              placeholder="Escolha um cargo"
              value={memberRole}
              onSelect={(value) => setMemberRole(value)}
              style={{
                alignSelf: 'center',
              }}
            >
              {workspace.roles.map((role) => (
                <Option
                  key={role.id}
                  value={role.name}
                >
                  {role.name}
                </Option>
              ))}
            </Select>
            <Button onClick={() => handleCreateNewMember()} type="button">Convidar</Button>
          </InviteContainer>
          {members?.map((member) => {
            const isLoggedUser = user.id === member.user.id;
            const isAdmin = member.role.name === 'admin';

            return (
              <Row key={`Member-${member.email}`}>
                <img
                  src={`https://avatars.dicebear.com/api/initials/${member.user.name}.svg`}
                  alt={`${member.user.name} avatar`}
                />
                <Column id={member.user.email}>
                  <Row>
                    <label htmlFor={member.user.email}>
                      {member.user.name}
                    </label>
                    <Select
                      value={member.role.name}
                      disabled={isLoggedUser || isAdmin}
                      style={{
                        width: '88px',
                      }}
                    >
                      {roles.map((role) => (
                        <Option key={role.id} value={role.name}>{role.name}</Option>
                      ))}
                    </Select>
                  </Row>
                  <span>
                    {member.user.email}
                  </span>
                </Column>
              </Row>
            );
          })}
        </Column>
      </Modal>
      <button type="button" onClick={() => handleOpen()}>
        <img src={membersIcon} alt="members" />
      </button>
    </Container>
  );
}

MembersButton.propTypes = {
  workspace: PropTypes.shape({
    id: PropTypes.string.isRequired,
    members: PropTypes.arrayOf(PropTypes.shape({
    })),
    roles: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })),
  }).isRequired,
  workspaceAlreadySelected: PropTypes.bool,
};

MembersButton.defaultProps = {
  workspaceAlreadySelected: false,
};
